<template>

    <div class="outer-wrapper">

        <div class="card-row">

            <img src="../../../public/img/discoverCard.png" />
            <img src="../../../public/img/amcard.png" />
            <img src="../../../public/img/mscard.png" />
            <img v-if=" environment != 'Production' " src="../../../public/img/visa.png" @click.prevent="addCard" />
            <img v-else src="../../../public/img/visa.png"  />
        </div>
        <div class="payment-info-wrapper">

            <div class="payment-amount-wrapper">

                <p class="payment-title">Total</p>
                <p class="payment-total">${{ orderTotal }}</p>
            </div>

            <div class="payment-info-form" v-if="verifyIfShowForm">

                <div class="card-information-wrapper">

                    <div class="input-wrap" >

                        <p class="input-title">card number:</p>
                        <input v-if=" environment != 'Production' " type="number" v-model=" cardInfo.cardNumber " class="input-data" placeholder="Enter Card Number" />
                        <cleave v-else placeholder="Enter Card Number" class="input-data" :options="{ creditCard: true }" v-model=" cardInfo.cardNumber " ></cleave>
                    </div>
                    <div class="input-wrap" >

                        <p class="input-title">name:</p>
                        <input type="text" v-model=" cardInfo.name " class="input-data" autocomplete="cc-name" spellcheck="false" />
                    </div>
                    <div class="small-sizing-inputs">

                        <div class="input-wrap" >

                            <p class="input-title">exp month:</p>
                            <select v-model=" cardInfo.expMo " class="input-data">

                                <option v-for=" n in 12 " :key=" n "> {{ n }} </option>
                            </select>
                        </div>
                        <div class="input-wrap" >

                            <p class="input-title">exp year:</p>
                            <select v-model=" cardInfo.expYr " class="input-data">

                                <option v-for=" n in 12 " :key=" n "> {{ currentYear + n - 1 }} </option>
                            </select>
                        </div>
                    </div>

                    <div class="small-sizing-inputs">

                        <div class="input-wrap" >

                            <p class="input-title">cvv:</p>
                            <input type="text" :maxlength="cardInfo.maxCvv" v-model=" cardInfo.cvv " class="input-data" />
                        </div>

                        <div class="input-wrap">

                            <p class="input-title">zip:</p>
                            <input type="text" :maxlength="cardInfo.maxZip" v-model=" cardInfo.zip " class="input-data" autocomplete="shipping postal-code"/>
                        </div>
                    </div>

                </div>
            </div>

            <div class="payment-cof-options-wrapper" v-if="verifyIfShowForm">

                <div class="input-style-inner-wrapper">

                    <input
                        id="saveCof"
                        type="checkbox"
                        v-model=" saveCardOnFile "
                    />
                    <label for="saveCof">Save Card on File</label>
                </div>
            </div>
            <OrderError />
            <div class="pay-button-wrapper" >

                <button :class=" relevantClasses " type="button" :disabled=" !formValid || isLoadingOrder" @click=" submitOrder() " v-if="verifyIfShowForm">

                    <font-awesome-icon class="lock-icon" v-if=" formValid && !isLoadingOrder " icon="lock-open"/>
                    <font-awesome-icon class="lock-icon" v-else icon="lock"/>
                    Pay ${{ orderTotal }}
                </button>
                <button class="button btn-aqua" type="button"  @click=" submitOrderZero() " v-if="!verifyIfShowForm">

                    <font-awesome-icon class="lock-icon" v-if=" !verifyIfShowForm && !isLoadingOrder " icon="lock-open"/>
                    <font-awesome-icon class="lock-icon" v-else icon="lock"/>
                    Submit Order
                </button>

            </div>
        </div>
        <div :class=" overlayClass " v-if="isLoadingOrder"><b>Please wait. Do not go back or refresh</b></div>
        <div v-if="isLoadingOrder">
            <loader object="#fcfcfc" color1="#ffffff" color2="#17fd3d" size="11" speed="1.1" bg="#343a40" objectbg="#999793" opacity="5" disableScrolling="true" name="dots"></loader>
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import Cleave from 'vue-cleave';
    import OrderError from '../misc/OrderError';
    import { mapGetters } from 'vuex';

    export default {

        name: 'payment',
        data: function(){

            return {

                cardInfo: {

                    cardNumber : '',
                    name       : '',
                    expMo      : '',
                    expYr      : '',
                    cvv        : '',
                    address    : '',
                    city       : '',
                    state      : '',
                    zip        : '',
                    maxCvv     : '4',
                    maxZip     : '5'
                },
                bonusCard: [],
                subTotalBefore:null,
                subTotalAfter:null,
                env         : process.env.VUE_APP_ENVIRONMENT,
                deliveryFee:0
            }
        },
        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav);
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener("beforeunload", this.preventNav);
            });
        },
        beforeRouteLeave(to, from, next) {
            if ( this.isLoadingOrder ) {
                if ( !window.confirm("Leave without saving?") ) {
                    return;
                }
            }
            next();
        },
        methods: {
            preventNav(event) {
                if (!this.isLoadingOrder) return;
                    event.preventDefault();
                    event.returnValue = "";
            },
            verifyBonusCard(){
                let currentMerchant = this.$store.getters['merchant/currentMerchant'];
                let currentCard = this.$store.getters['cards/currentCard'];
                if (currentCard != null ){
                    if (currentMerchant.merchantId == currentCard.Merchant.merchantId ) {
                        //console.log("that is the promotion card",this.getPromotionCard);
                            this.bonusCard.push({prepaidAccountId:currentCard.PrepaidAccount.prepaidAccountId, amount:this.getPromotionCard})

                        //this.bonusCard.bonus.prepaidAccountId = currentCard.PrepaidAccount.prepaidAccountId;
                        //this.bonusCard.bonus.amount = currentCard.PrepaidAccount.balance;
                        //this.bonusCard = currentCard;
                    } else {

                        this.bonusCard = [];
                    }

                } else {
                    this.bonusCard = [];
                }
            },
            getSubTotals( ){
                let beforeSubTotal = this.$store.getters['orderTab/getCost'];
                let afterSubTotal = this.$store.getters['orderTab/getCostAfterBonusCard'];

                this.subTotalBefore = beforeSubTotal;
                this.subTotalAfter = afterSubTotal;
            },
            submitOrder(){

                if( this.formValid && !this.isLoading ){

                    const formattedData = {

                        'card'     : this.cardInfo.cardNumber.replace( /\s/g, "" ),
                        'expYear'  : this.cardInfo.expYr,
                        'expMonth' : this.cardInfo.expMo,
                        'code'     : this.cardInfo.cvv,
                        'name'     : this.cardInfo.name,
                        'city'     : this.cardInfo.city,
                        'state'    : this.cardInfo.state,
                        'zip'      : this.cardInfo.zip
                    };

                    this.$store.dispatch( 'orderTab/processPaymentInfo', formattedData )
                    .then( ( encryptedData ) => {

                        if ( encryptedData ) {

                            //console.log( 'Encrypted Data: ', encryptedData );
                            // also passing in saveCard to signal if we should save the card information
                            //console.log( 'COF Data: ', this.saveCard );
                            const data = {

                                encryptedData  : encryptedData,
                                saveCard : this.saveCard,
                                useCard : encryptedData,
                                delivery : this.deliverySelected,
                                bonus: this.bonusCard,
                                subTotalBefore: parseFloat(this.subTotalBefore).toFixed(2),
                                subTotalAfter: this.subTotalAfter
                            };

                            console.log('orderWasChanged::: ', this.orderWasChanged);

                            if (this.orderWasChanged) {
                                this.$store.dispatch( 'orderTab/resetError');
                            }
                            

                            if (this.getCurrentCloverOrderId == '') {
                                console.log('Submit New Order First Time...');
                                this.$store.dispatch( 'orderTab/submitOrder', data );

                            } else {

                                this.$store.dispatch( 'orderTab/isOrderWasChanged', null, { root : true })

                                console.log('Submit Same CloverOrderId: ', this.getCurrentCloverOrderId);
                                this.$store.dispatch( 'orderTab/submitAgainPayment', data );
                            }
                            
                        } else {

                            this.$store.commit( 'orderTab/orderError', 'Unexpected error processing your card, please check your information' );
                        }
                    })
                }
            },
            submitOrderZero(){

                if( !this.isLoading ){

                            // also passing in saveCard to signal if we should save the card information
                            //console.log( 'COF Data: ', this.saveCard );
                            const data = {
                                delivery : this.deliverySelected,
                                bonus: this.bonusCard,
                                subTotalBefore: this.subTotalBefore,
                                subTotalAfter: this.subTotalAfter
                            };
                            //console.log("payment data without credit card");
                            //console.log(data);

                            this.$store.dispatch( 'orderTab/submitOrder', data );
                }
            },
            addCard() {
                this.cardInfo.cardNumber = process.env.VUE_APP_DEV_CARD;
            }
        },
        computed: {

            ...mapGetters({

                unitedStates                : 'unitedStates',
                orderTotal                  : 'orderTab/orderTotal',
                orderError                  : 'orderTab/orderError',
                deliverySelected            : 'merchant/deliverySelected',
                isLoading                   : 'isLoading',
                hasCardOnFile               : 'cards/hasCardOnFile',
                cof                         : 'cards/cof',
                saveCard                    : 'orderTab/saveCard',
                currentCard                 : 'cards/currentCard',
                currentMerchant             : 'merchant/currentMerchant',
                getPromotionCard            : 'orderTab/getPromotionCard',
                getCostAfterBonusCard       : 'orderTab/getCostAfterBonusCard',
                getCurrentCloverOrderId     : 'orderTab/cloverOrderId',
                orderWasChanged             : 'orderTab/orderWasChanged',
                isLoadingOrder              : 'orderTab/isLoadingOrder',
                currentLocation             : 'merchant/currentLocation',
                merchantIdCrocante          : 'merchantIdCrocante',
            }),
            verifyIfShowForm(){
                if ( this.subTotalAfter > 0 || this.deliveryFee > 0 ) {
                    return true;
                }
                this.$store.commit( 'orderTab/updateTip', 0 );
                return false;
            },
            formValid(){

                let monthNow = new Date().getMonth()+1;

                if( [ null, '' ].includes( this.cardInfo.cardNumber ) || ![ 15, 16 ].includes( this.cardInfo.cardNumber.replace( /\s/g, "" ).length ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.name       ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.expMo      ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.expYr      ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.cvv        ) || ![ 3, 4 ].includes( this.cardInfo.cvv.length ) || this.cardInfo.cvv.match( /[a-z]/i ) ) return false;
                if( [ null, '' ].includes( this.cardInfo.zip        ) || ![ 5 ].includes( this.cardInfo.zip.length )  || this.cardInfo.zip.match( /[a-z]/i ) ) return false;
                if( this.cardInfo.expMo < monthNow && this.cardInfo.expYr == this.currentYear  ) return false;
                return true;
            },
            currentYear : () => new Date().getFullYear(),
            saveCardOnFile : {

                get: function(){

                    return this.saveCard;
                },
                set: function( externalId ){

                    this.$store.dispatch( 'orderTab/toggleSaveCard' );
                }
            },
            relevantClasses(){

                const base = [ 'button' ];
                base.push( ( !this.isLoadingOrder ) ? ( ( this.currentLocation.merchantId == this.merchantIdCrocante ) ? 'btn-brown' : 'btn-aqua' ) : 'hide-all-element' );
                return base.join( ' ' );
            },
            overlayClass(){

                const base = [ 'overlay ' ];
                base.push( ( this.currentLocation.merchantId == this.merchantIdCrocante ) ? 'outPopUp color-font-crocante' : 'outPopUp color-font-xo' );
                return base.join( ' ' );
            },
            environment(){

                return process.env.VUE_APP_ENVIRONMENT
            }
        },
        components: {

            FontAwesomeIcon,
            Cleave,
            OrderError
        },
        created(){
            this.verifyBonusCard();
            this.getSubTotals();
            if (this.orderTotal == 0 && verifyIfShowForm) {
                console.log('totalAmount = 0');
                this.$router.replace({
                    name: 'order-duplicate-failure'
                });
            }
            this.deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
            console.log(this.deliveryFee);
            this.$store.commit( 'orderTab/updateTip', this.$store.getters[ 'orderTab/orderTip' ] );
            this.$store.commit( 'orderTab/setFees', this.$store.getters[ 'orderTab/getDeliveryOtherFee' ]);
        }
    }
</script>

<style scoped>

    .card-row {

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 20px 30px 0px;
        max-width: 800px;
        margin: 0px auto;
    }
    .card-row > img {

        width: 22%;
    }

    .payment-cof-options-wrapper {

        display: flex;
        align-items: center;
        margin: 20px auto;
        padding: 0px 15px;
    }

    .payment-cof-action {

        flex: 1;
        text-align: center;
    }

    .payment-cof-action > button {

        margin: 0px 10px;
        box-sizing: border-box;
    }

    .payment-amount-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 115px;
    }
    .payment-title{

        font-size: 22px;
    }
    .payment-total{

        font-weight: bold;
        font-size: 30px;
    }

    .card-information-wrapper {

        margin: 0px 0px 15px;
        padding: 0px 15px;
    }

    .input-title {

        font-size: 18px;
    }
    .input-data {

        width: 100%;
        margin: 3px 1px;
        height: 45px;
        border-radius: 8px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        font-size: 18px;
        transition: all 0.2s ease-in;
    }
    .input-data:focus {

        outline: none;
        border: 1px solid blue;
        box-shadow: 0px 2px 20px -5px blue;
    }
    .input-data::-webkit-input-placeholder {

        text-align: center;
    }

    .small-sizing-inputs {

        display: flex;
        justify-content: space-between;
    }
    .small-sizing-inputs > .input-wrap {

        width: 100%;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 1 ) > .input-data {

        border-radius: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        font-size: 14px;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 2 ) > .input-data {

        border-radius: 0;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }


    .pay-button-wrapper {

        padding: 0px 15px;
        margin-bottom: 15px;
    }
    .pay-button-wrapper > button {

        width: 100%;
        height: 50px;
        font-size: 18px;
    }

    .lock-icon {

        width: 25px;
    }

    .hide-all-element {
        display: none
    }

    .overlay {
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
    }

    .color-font-crocante {
        color: #4A2612;
        background: #DFEC72;
    }

    .color-font-xo {
        color: white;
        background: rgba(240, 11, 11, 0.822)
    }

    .outPopUp {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000;
        left: 0;
        top: 0;
    }

</style>
